export enum PartnerStatusMessagesValues {
  DISALLOW_BY_SUSPENSION = 'Registering new plans is currently unavailable. Your account is under suspend.',
  DISALLOW_BY_AUDITING = 'Registering new plans is currently unavailable. Your account is under audit.',
  DISALLOW_BY_REVIEWING = 'Registering new plans is currently unavailable. Your account is under review.',
}
